import { ProductCatalogIngestionStatus } from '@/features/product-catalog/components/ProductCatalogIngestionStatus'
import type {
  FileUploadStatus,
  IngestionProgress,
} from '@/shared/hooks/api/productSource'

type IngestionStatus = 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED'

export function EPlanFileUploadStatus({
  productId,
  sourceId,
  filePathInBucket,
  fileUploadStatus,
  ingestionStatus,
  ingestionStage,
  ingestionProgress,
  ingestionErrorCode,
  ingestionPartialResult,
  ingestionMissingPages,
  isUploading = false,
}: {
  productId: string
  sourceId: string
  fileUploadStatus: FileUploadStatus
  filePathInBucket?: string
  ingestionStatus: IngestionStatus
  ingestionStage: string | null
  ingestionProgress: IngestionProgress | null
  ingestionErrorCode: string | null
  ingestionPartialResult: boolean | null
  ingestionMissingPages: string[]
  isUploading?: boolean
}) {
  return (
    <ProductCatalogIngestionStatus
      productId={productId}
      sourceId={sourceId}
      status={ingestionStatus}
      fileUploadStatus={fileUploadStatus}
      filePathInBucket={filePathInBucket}
      isUploading={isUploading}
      stage={ingestionStage}
      progress={ingestionProgress}
      ingestionErrorCode={ingestionErrorCode}
      partialResult={ingestionPartialResult}
      missingPages={ingestionMissingPages}
    />
  )
}
